export var SDK_VERSION = '6.13.1';
//# sourceMappingURL=version.js.map